"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var colorsV2_1 = __importDefault(require("../../../assets/jss/colorsV2"));
var material_kit_pro_react_1 = require("../../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    return (0, core_1.makeStyles)({
        container: material_kit_pro_react_1.container,
        content: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center'
        },
        forgot: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            width: '100%',
            marginBottom: theme.spacing(3),
            marginTop: theme.spacing()
        },
        text: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        register: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(),
            alignSelf: 'stretch'
        },
        registerButton: {
            display: 'flex',
            gap: theme.spacing(),
            minHeight: '32px',
            padding: theme.spacing(0, 1),
            justifyContent: 'center',
            alignItems: 'center'
        },
        primaryText: {
            color: colorsV2_1.default.palette.primaryP500.hex()
        },
        submit: {
            padding: theme.spacing(0, 1.5)
        },
        submitButton: {
            display: 'flex',
            minWidth: '120px',
            minHeight: '48px',
            padding: theme.spacing(0, 1.5),
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(),
            margin: 0
        },
        disabledSubmitButton: {
            margin: '0px !important'
        },
        requiredText: {
            display: 'flex',
            width: '100%'
        },
        inputContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: theme.spacing(3),
            alignSelf: 'stretch'
        },
        form: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: theme.spacing(0.5),
            alignSelf: 'stretch',
            minHeight: '112px'
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map